<div #map id="map"></div>
<!-- Hide controls until they are moved into the map. -->
<div style="display:none">
  <div class="controls zoom-control">
    <button class="zoom-control-in" title="Zoom In" i18n-title >+</button>
    <button class="zoom-control-out" title="Zoom Out" i18n-title >−</button>
  </div>

  <div class="controls-container">
    <div class="controls traffic-control" *ngIf="trafficLayerEnabled">
      <button class="traffic-contol-button" [class.selected]="shouldDisplayTraffic" (click)="toggleTraffic()" i18n>Traffic</button>
    </div>

    <div class="controls maptype-control">
      <div class="maptype-map-container">
        <button class="maptype-control-map" title="Show road map" i18n-title i18n>Map</button>
        <div class="maptype-dropdown terrain-maptype hidden">
          <label><input type="checkbox" name="terrain" value="true"> &nbsp;<ng-container i18n>Terrain</ng-container></label>
        </div>
      </div>

      <div class="maptype-satellite-container">
        <button class="maptype-control-satellite" title="Show satellite imagery" i18n-title i18n>Satellite</button>
        <div class="maptype-dropdown satellite-labels-maptype hidden">
          <label><input type="checkbox" name="satellite-labels" value="true" checked> &nbsp;<ng-container i18n>Labels</ng-container></label>
        </div>
      </div>
    </div>

    <div class="controls fullscreen-control">
      <button title="Toggle Fullscreen" i18n-title>
        <div class="fullscreen-control-icon fullscreen-control-top-left"></div>
        <div class="fullscreen-control-icon fullscreen-control-top-right"></div>
        <div class="fullscreen-control-icon fullscreen-control-bottom-left"></div>
        <div class="fullscreen-control-icon fullscreen-control-bottom-right"></div>
      </button>
    </div>
  </div>
</div>
